import React from "react"
import { Link } from "react-router-dom"
import About from "../Components/About/About"
import Path from "../Components/Path/Path"
import Blog from "../Components/Blog/Blog"
import Footer from '../Components/Outlets/Footer'
import Nav from '../Components/Outlets/Nav'

const HomePage = () => {
	return (
		<div>
			<Nav />
			<div className="page-main">
				<div className='home-page'>
					<div className="container-main">
						<div className="home-page-content">
							<h1 className="home-main-heading montserrat">Nurturing the Next Generation with <span className="montserrat block-text">Éloria International Girls School</span> </h1>
							<p className="home-sub-text">We aim to facilitate a fertile ground for the overall growth of the next generation with their souls engraved in spiritual values and their skills ranging from coding to critical thinking chiselled to meet the unseen future of science and technology.</p>
							<Link className="btn enquire-btn" to='/admission'>Admission   2026 - 27</Link>
						</div>
					</div>
				</div>
				<About />
				<Path />
				<Blog />
			</div>
			<Footer />
		</div>
	)
}

export default HomePage;